import { IEirSalesNle } from "@modules/eirSalesFacade/interfaces/models/IEirSalesNLE";
import { mapEirSalesNLEResponse } from "@modules/eirSalesFacade/mappers/mapEirSalesNLEResponse";
import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { EIR_SALES_FACADE_ENDPOINT } from "./endpoint";

export const getNLE = (prequalId: string, options: IFetchOptions = {}) =>
    fetcher<IEirSalesNle>(`${EIR_SALES_FACADE_ENDPOINT}nle/${prequalId}`, {
        mapper: mapEirSalesNLEResponse,
        ...options,
    });
